import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, shareReplay, switchMap } from 'rxjs/operators'
import { HttpClient, HttpParams } from '@angular/common/http'
import { catch301Errors, FloApiResponseCollection } from '../../shared/models/api-response.model'
import { Video } from '../../shared/models/video.model'
import { EventHubGetProvider } from '../../funnel/signup/signup.interface'
import { VerticalService } from '../../singleton-services/vertical.service'
import { SiteIds } from '../../shared/models/site.model'
import { FloEvent } from '@flocasts/flosports30-types/dist/entity'
import { FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'
import { SearchMeta } from '../../singleton-services/search-data.service.interface'
import { EXPERIENCE_API_LEGACY_CORE_EVENTS_PATH, EXPERIENCE_API_VERSION } from 'src/app/app.config'

@Injectable({
  providedIn: 'root'
})
export class EventsService implements EventHubGetProvider {
  constructor(private http: HttpClient, private readonly verticalService: VerticalService) {}

  /**
   * @deprecated avoid using
   * Same code is in live/event.service
   */
  public get timeZone(): any {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (err) {
      return ''
    }
  }

  public DEFAULT_EVENT_LIMIT = 14

  public getEvent(id: number): Observable<FloResponse<FloEvent, {}>> {
    return this.verticalService.siteId$.pipe(
      switchMap(siteId => {
        return this.http
          .get<FloResponse<FloEvent, {}>>(`${EXPERIENCE_API_LEGACY_CORE_EVENTS_PATH}/${id}`, {
            params: { version: EXPERIENCE_API_VERSION, site_id: siteId },
            observe: 'response'
          })
          .pipe(resp => catch301Errors(resp))
      }),
      map(resp => {
        return resp.body ?? ({} as FloResponse<FloEvent, {}>)
      })
    )
  }

  public getEventVideos(
    id: number,
    sort: string,
    limit: number,
    page?: number
  ): Observable<FloResponse<ReadonlyArray<Video>, SearchMeta>> {
    return this.verticalService.siteId$.pipe(
      switchMap(siteId => {
        return this.http
          .get<FloResponse<ReadonlyArray<Video>, SearchMeta>>(
            `${EXPERIENCE_API_LEGACY_CORE_EVENTS_PATH}/${id}/associations/videos`,
            {
              params: new HttpParams()
                .set('sort', sort)
                .set('limit', limit.toString())
                .set('version', EXPERIENCE_API_VERSION)
                .set('site_id', siteId.toString())
            }
          )
          .pipe(catch301Errors)
      })
    )
  }
}
